import { render, staticRenderFns } from "./WarehouseManagementCreationPage.vue?vue&type=template&id=a5cb045a&scoped=true"
import script from "./WarehouseManagementCreationPage.vue?vue&type=script&lang=js"
export * from "./WarehouseManagementCreationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cb045a",
  null
  
)

export default component.exports